import * as React from 'react';
import { generateCurvePath, generateLinearPath, getMarkerConfig, } from '../../';
export const LinkDefault = ({ config, link, startPos, endPos, onLinkMouseEnter, onLinkMouseLeave, onLinkClick, isHovered, isSelected, fromNode, toNode, }) => {
    var _a, _b;
    const pathGenerator = ((_a = config.linkConfig) === null || _a === void 0 ? void 0 : _a.shape) === 'linear' ? generateLinearPath : generateCurvePath;
    const points = pathGenerator(startPos, endPos, link, fromNode, toNode);
    const markers = getMarkerConfig(config, link);
    const showOutline = ((_b = config.linkConfig) === null || _b === void 0 ? void 0 : _b.outline) !== false;
    return (React.createElement("svg", { style: { overflow: 'visible', position: 'absolute', cursor: 'pointer', left: 0, right: 0 } },
        React.createElement("defs", null,
            markers.from.marker,
            markers.to.marker),
        React.createElement("path", { d: points, stroke: "cornflowerblue", strokeWidth: "3", fill: "none", markerStart: `url(#${markers.from.id})`, markerEnd: `url(#${markers.to.id})` }),
        showOutline && (React.createElement("path", { d: points, stroke: "cornflowerblue", strokeWidth: "20", fill: "none", strokeLinecap: "round", strokeOpacity: (isHovered || isSelected) ? 0.1 : 0, onMouseEnter: () => onLinkMouseEnter({ config, linkId: link.id }), onMouseLeave: () => onLinkMouseLeave({ config, linkId: link.id }), onClick: (e) => {
                onLinkClick({ config, linkId: link.id });
                e.stopPropagation();
            } }))));
};
